module.exports = __webpack_public_path__ + "img/bait-and-switch.e70a18e9.jpg";